<!-- eslint-disable max-lines -->
<template>
  <div
    class="flex flex-col flex-none w-56 border-r border-base-30 aha-left-column bg-base-0"
    :class="{'show-grid-slide': showingSlideGrid,
             'min-w-max': !showingSlideGrid,
             'is-right-nav-active': rightNavActiveTab}"
  >
    <div v-if="!isBackstage" class="left-nav-upper__wrapper">
      <LeftNavUpper @addNewSlide="addNewSlide" :isSelectMode="isSelectMode" />
      <div
        v-if="showingSlideGrid"
        class="aha-slide-grid-action"
        :class="{'not-allow': isSelectMode, 'right-nav--opening': rightNavActiveTab}"
      >
        <div class="flex">
          <div class="grid-view__button-wrapper" @mouseup.stop>
            <div v-if="isDisableEditPresentation" class="overlay-disable-grid-action"></div>
            <ul>
              <li class="relative" v-tooltip="$i18nPresenter.t('Duplicate')">
                <a
                  :disabled="isSelectMode"
                  @click="duplicateSelectedSlides()"
                >
                  <aha-icon
                    name="duplicate"
                    class="mr-2 text-primary-90"
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                  />
                  <span class="grid-view__button-label">
                    {{ $i18nPresenter.t('Duplicate') }}
                  </span>
                </a>
              </li>
              <li
                v-tooltip="{content: isGuestUser ?
                  $i18nPresenter.t('This feature is disabled in Demo Mode') : $i18nPresenter.t('Copy to...')}"
                class="relative"
                :class="{'disabled': isGuestUser}"
              >
                <a
                  :disabled="isSelectMode || isGuestUser"
                  @click="copySlidesTo()"
                >
                  <font-awesome-icon icon="file-import" class="mr-2 text-primary-90" />
                  <span class="text-base-90 hover:text-primary-90 grid-view__button-label">
                    {{ $i18nPresenter.t('Copy to...') }}
                  </span>
                </a>
              </li>
              <li class="relative" v-tooltip="$i18nPresenter.t('Rearrange…')">
                <a
                  :disabled="isSelectMode"
                  class="relative"
                >
                  <font-awesome-icon icon="exchange-alt" class="mr-2 text-primary-90" />
                  <span class="text-base-90 grid-view__button-label">{{ $i18nPresenter.t('Rearrange…') }}</span>

                  <select
                    v-model="selectedOrder"
                    class="slide-rearrange-options"
                    @change="rearrangeSelectedSlides()"
                  >
                    <option disabled>
                      {{ $i18nPresenter.t('Move slide to position:') }}
                    </option>
                    <option
                      v-for="(option,slideIndex) in $store.state.presentation.slides"
                      :key="slideIndex"
                      :value="slideIndex"
                    >
                      {{ slideIndex + 1 }}
                    </option>
                  </select>
                </a>
              </li>
              <li
                class="relative"
                v-tooltip="$i18nPresenter.t('Reset results')"
                :class="{'disabled': isResetResultsButtonDisabled}"
              >
                <a
                  class="reset-results-button"
                  @click="!isResetResultsButtonDisabled && clearSelectedSlides()"
                >
                  <aha-icon name="reset" class="mr-2 text-primary-90" />
                  <span
                    class="text-base-90 hover:text-primary-90 grid-view__button-label
                    max-w-24 inline-flex overflow-hidden text-ellipsis whitespace-nowrap"
                  >{{ $i18nPresenter.t('Reset results') }}</span>
                </a>
              </li>
              <li
                class="relative aha-slide-delete-button"
                :class="{'disabled': isSelectAll}"
                v-tooltip="$i18nPresenter.t('Delete')"
              >
                <a
                  @click="deleteSelectedSlides"
                >
                  <font-awesome-icon icon="trash-alt" class="mr-2 text-red-50" />
                  <span class="text-base-90 grid-view__button-label">{{ $i18nPresenter.t('Delete') }}</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="flex items-center justtify-center">
            <ul>
              <li class="pl-6" @click="toggleSelectMode()">
                <aha-button
                  v-if="!isSelectMode"
                  variant="base"
                  class="relative -top-0.5"
                >
                  {{ $i18nPresenter.t('Select...') }}
                </aha-button>
                <aha-button
                  v-else
                  variant="primary"
                  class="relative -top-0.5"
                >
                  {{ $i18nPresenter.t('Cancel') }}
                </aha-button>
              </li>
            </ul>
          </div>
        </div>
        <div class="aha-slide-grid-close" @click="closeSlideGrid">
          <font-awesome-icon
            icon="times"
            class="ml-2.5 cursor-pointer font-bold text-base-60 hover:text-primary-90"
          />
        </div>
      </div>
    </div>
    <div
      id="leftScrollBar"
      ref="leftScrollBar"
      class="flex-grow overflow-y-auto"
    >
      <draggable
        v-bind="dragOptions"
        ref="drag-list-wrapper"
        v-model="$store.state.presentation.slides"
        class="pb-2 list-group"
        :sort="!isDisableEditPresentation && !isBackstage"
        :bus="bus"
        :class="{
          'list-group-grid': showingSlideGrid,
          'select-mode': isSelectMode,
        }"
        tag="ul"
        @start="onDragStart"
        @end="onDragEnd"
        @change="handleDragAndDropSlide"
        @select="selectToDrag"
        @deselect="deselectToDrag"
        v-click-outside="clickOutsideSlideList"
      >
        <li
          v-for="(item, index) in slides"
          :id="'slide-' + item.id"
          :key="item.id + '-' + item.order"
          class="list-group-item"
          :data-index="index"
          :class="{
            'active-slide': getActiveSlide(item),
            'icon-inside-black': item.textColour == '#ffffff',
            'has-icon-inside': item.typeObj && item.typeObj.iconInside,
            'select-slide': isSlideSelected(item),
          }"
        >
          <div
            :id="`slide-item-${item.id}`"
            :ref="`slide-index-${index}`"
            class="aha-slide-item"
            :class="item.type"
          >
            <div class="aha-slide-order">
              <ToolBoxSideLeft
                :item="item"
                :index="index"
                @focusNoteAndMakeSlideActive="focusNoteAndMakeSlideActive"
              />
            </div>
            <div
              v-if="!isDisableOpenSettingSlide"
              :id="`slide-kebab-${index}`"
              class="aha-slide-setting"
              @click.stop="openSettingSlide(index, item)"
            >
              <font-awesome-icon
                icon="ellipsis-v"
                class="aha-slide-setting-icon"
              />
            </div>

            <div
              class="aha-slide-content"
              :class="{
                'is-content-slide': item.type === 'freestyle'
              }"
              :style="{ 'color': item.textColour }"
              @contextmenu.prevent="openSettingSlide(index, item, $event)"
            >
              <div class="h-full" @click="makeSlideActive(item)">
                <div
                  v-if="canViewThemeGallery"
                  class="absolute grid h-full w-full top-0 left-0 rounded overflow-hidden"
                >
                  <div
                    class="bg-base-color col-start-1 row-start-1 w-full h-full"
                    :style="{ backgroundColor: currentPresentationTheme.baseColour }"
                  ></div>
                  <div
                    v-if="currentPresentationTheme?.backgroundImage"
                    class="bg-image col-start-1 row-start-1 bg-cover w-full h-full bg-no-repeat bg-center"
                    :style="{
                      backgroundImage: `url(${currentPresentationTheme.backgroundImage?.large})`,
                      opacity: currentPresentationTheme.visibility / 100 }"
                  ></div>
                </div>
                <div
                  class="rounded absolute h-full w-full top-0 left-0"
                  :style="{ 'background-color': item.baseColour, 'color': item.textColour }"
                />
                <div
                  v-if="item.backgroundImage"
                  class="aha-slide-bg-image"
                  :style="{
                    'opacity': item.visibility / 100,
                    'background-image': 'url(' + backgroundImage(item) + ')',
                  }"
                  :class="getSlideBgSize(item.backgroundSize)"
                />

                <div
                  v-if="(item.image && item.type == 'image'
                    && item.imageType == 'background')
                    || (item.image && (item.type == 'document' || item.type === 'freestyle'))"
                  class="aha-slide-bg-image"
                  :style="{ 'background-image': 'url(' + item.image.thumbnail + ')' }"
                  :class="getSlideBgSize(item.backgroundSize)"
                />

                <SlideTypeIcon
                  v-if="item.type !== 'freestyle'"
                  :slide-type="item.type"
                  :child-type="item.slideType"
                  :leftSide="true"
                  :textColour="item.textColour"
                  :class="{
                    'aha-slide-thumbnail-wrapper':
                      ((item.imageType == 'background' && item.type === 'image')
                        || item.type == 'document'
                      ) && item.image,
                    'dark': item.textColour == '#313131'}"
                />
                <FreestyleThumbnailPreview
                  v-if="item.type === 'freestyle'"
                  :slide="item"
                  :location="'preview'"
                />
                <div
                  class="aha-slide-title"
                  :class="{
                    'aha-slide-title-bg':
                      (item.imageType == 'background'
                        && item.type =='image'
                        && item.image && item.title
                        && item.title !== ' ')
                      || (item.type =='document'
                        && item.image
                        && item.title
                        && item.title !== ' '
                      ),
                    'dark': item.textColour == '#313131',
                    'opacity-0': item.type === 'freestyle'}"
                >
                  {{ item.title }}
                </div>
                <font-awesome-icon
                  v-if="item.notCheckCorrectAnswer"
                  v-tooltip="noCorrectAnswerTooltip"
                  icon="info-circle"
                  class="absolute text-lg text-yellow-100 -top-2 -right-2 z-5 aha-slide_infoicon"
                />
                <img
                  src="@/assets/images/pro.svg"
                  class="absolute text-lg text-yellow-100 -top-2 -right-2 z-5 aha-slide_infoicon"
                  v-if="!item.notCheckCorrectAnswer && checkPlanBenefitLimitation(item)"
                >
              </div>
              <div class="slide-drag" />
            </div>
          </div>
        </li>
        <li v-if="!isBackstage && !disableAddNew" class="create-context">
          <div class="aha-slide-item create-context-item">
            <div
              class="aha-slide-content"
              :class="{
                'pointer-events-none overlay-disable-grid-action': isDisableEditPresentation
              }"
            >
              <div
                class="flex items-center justify-center h-full left-nav-upper__new-slide btn-cta"
                v-tooltip="$i18nPresenter.t('New slide')"
                @click.prevent="addNewSlide('Click on Side Left CTA', -1)"
              >
                <font-awesome-icon
                  icon="plus"
                  class="text-base text-base-80"
                />
              </div>
            </div>
          </div>
        </li>
      </draggable>
    </div>
    <div
      v-if="!isBackstage && !isEnableAddinPowerpoint"
      class="aha-left-column-bottom"
      @mouseup.stop
    >
      <div
        class="aha-button-grid-view"
        title="Switch to Grid View"
      >
        <span v-if="!showingSlideGrid" @click="openSlideGrid">
          <font-awesome-icon icon="th-large" class="mr-2.5 text-lg font-bold text-primary-90" />
          {{ $i18nPresenter.t('Grid View') }}
        </span>

        <span
          v-if="showingSlideGrid"
          class="text-base-90 hover:text-primary-90 close-gridview"
          @click="closeSlideGrid"
        >
          <font-awesome-icon icon="times" class="mr-2.5 text-md text-base-60 icon-close" />
          {{ $i18nPresenter.t('Close') }}
        </span>
      </div>
      <div class="flex-1" />
      <div
        v-if="selectedSlideIds.length && selectedSlideIds.length > 1 && showingSlideGrid"
        class="flex px-6 align-middle text-base-90"
      >
        {{ $i18nPresenter.t('selectedSlides', {number: selectedSlideIds.length}) }}
        <span @click="deselectAllSlides()">
          <font-awesome-icon
            icon="times"
            class="ml-2.5 text-md text-base-60 icon-close cursor-pointer hover:text-primary-90"
          />
        </span>
      </div>
    </div>

    <!-- <ModalDeleteSlide
      v-if="showModalSlideDelete"
      :slides="modalData.slides"
      :title="modalData.title"
      :content="modalData.content"
      @hide="handleCloseModalDeleteSlide()"
      @deselectAllSlides="deselectAllSlides"
      @makeSlideActive="makeSlideActive"
    /> -->

    <modal-clear-data-slide
      v-if="showModalClearDataSlide"
      :selectedSlides="gridViewSelectedSlides"
      @hide="handleCloseModalClearDataSlide()"
      @makeSlideActive="makeSlideActive"
    />

    <modal-import
      v-aha-emit-action.view
      v-if="$store.state.openImportModal"
      @hideModal="hideModalUploadPpt"
    />
    <modal-slide-limit
      v-if="showModalLimitSlides"
      @hide="hideModalSlideLimit"
    />
    <div v-if="!canUseCopySharedSlides">
      <SlideCopy
        v-if="visibleModalCopySlide"
        :title="$i18nPresenter.t('Copy to another presentation')"
        :get-items="targetSlide ? () => [targetSlide] : getActiveOrSelectedSlides"
        @hide="visibleModalCopySlide = false"
      />
    </div>
    <div v-else>
      <SlideCopyV2
        v-if="visibleModalCopySlide"
        :title="$i18nPresenter.t('Copy to another presentation')"
        :get-items="targetSlide ? () => [targetSlide] : getActiveOrSelectedSlides"
        @hide="visibleModalCopySlide = false"
      />
    </div>
    <aha-context-menu
      v-show="targetSlide"
      ref="aha-context-menu"
      :target="`slide-kebab-${indexSettingSlide}`"
      :x="targetX"
      :y="targetY"
    >
      <ul>
        <li
          v-show="targetSlide && targetSlide.id"
          class="context-menu-item context-menu-create left-nav-upper__new-slide"
          @click.prevent="addNewSlide('Click on Context menu', targetSlide.index)"
        >
          <font-awesome-icon icon="plus" class="text-base-70 fa-fw" />
          <span>{{ $i18nPresenter.t('New slide') }}</span>
        </li>
        <li
          v-show="targetSlide && targetSlide.id"
          class="context-menu-item context-menu-duplicate"
          @click.prevent="duplicateSingleSlide(targetSlide, targetSlide.index)"
        >
          <aha-icon
            name="duplicate"
            class="text-base-70"
            width="18"
            height="18"
            viewBox="0 0 20 20"
          />
          <span class="text-duplicate-slide">{{ $i18nPresenter.t('Duplicate') }} </span>
          <aha-shortcut-key keyName="D" hasCtrl v-if="!isSmallScreen" />
        </li>
        <li
          v-if="targetSlide && targetSlide.id && targetSlide.type !== 'qrcode'"
          v-tooltip="{
            content: isGuestUser ? $i18nPresenter.t('This feature is disabled in Demo Mode') : false,
            placement: 'right'
          }"
          class="context-menu-item"
          :class="{'disabled': isGuestUser}"
          :disabled="isGuestUser"
          @click.prevent="handleCopyIconClick(targetSlide)"
        >
          <font-awesome-icon icon="file-import" class="text-base-70 fa-fw" />
          <span>{{ $i18nPresenter.t('Copy to...') }}</span>
        </li>
        <li
          v-if="targetSlide && targetSlide.id"
          class="relative context-menu-item"
          @click.stop
        >
          <font-awesome-icon icon="exchange-alt" class="text-base-70 fa-fw" />
          <span>{{ $i18nPresenter.t('Rearrange...') }}</span>

          <div v-if="indexSettingSlide !== null">
            <select
              v-model="selectedOrder"
              class="slide-rearrange-options"
              @change="rearrangeSlides([targetSlide])"
            >
              <option disabled>
                {{ $i18nPresenter.t('Move slide to position:') }}
              </option>
              <option
                v-for="(option,slideIndex) in $store.state.presentation.slides"
                :key="slideIndex"
                :value="slideIndex"
              >
                {{ slideIndex + 1 }}
                <span v-if="slideIndex == targetSlide.index">{{ $i18nPresenter.t("(current position)") }}</span>
              </option>
            </select>
          </div>
        </li>
        <li
          v-if="targetSlide && targetSlide.id && targetSlide.type != 'leaderboard'"
          class="context-menu-item"
          @click.prevent="clearSingleSlide(targetSlide)"
        >
          <font-awesome-icon icon="redo" class="text-base-70 fa-fw" />
          <span>{{ $i18nPresenter.t('Reset results') }}</span>
        </li>
        <div
          v-if="targetSlide && targetSlide.id"
          class="my-1 border-b border-solid border-base-30"
          @click.stop
        />
        <li
          class="context-menu-item"
          @click.prevent="deleteSingleSlide(targetSlide)"
        >
          <font-awesome-icon icon="trash-alt" class="text-red-100 fa-fw" />
          <span class="text-red-100">{{ $i18nPresenter.t('Delete') }}</span>
        </li>
      </ul>
    </aha-context-menu>

    <ModalImportSheet v-if="openModalImportSheet" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Vue from 'vue'

import draggable from 'vuedraggable'
import * as Fraction from 'fraction.js'
import * as Sentry from '@sentry/vue'
import Config from '@/config'
import Util from '@/util'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'
import Socket from '@/socket'
import EventBus from '@/eventBus'
import eventCategories from '@/constant/eventCategories'
import ToolBoxSideLeft from './ToolBoxSideLeft.vue'
import Constants from '@/constant'
import { DEFAULT_THEME_ATTRIBUTES } from '@/constant/theme'
// api
import SlideApi from '@/api/slide'
import PresentationUtils from '@/utils/presentation'

import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'
import ModalImport from '@/components-v2/modals/Import.vue'
import ModalSlideLimit from '@/components-v2/modals/SlideLimit.vue'
import SlideCopy from '@/components-v2/common/slide-copy/SlideCopy.vue'
import SlideCopyV2 from '@/components-v2/common/slide-copy/SlideCopyV2.vue'
import SlideTypeIcon from '@/components-v2/common/slide-type-icon/SlideTypeIcon.vue'
import FreestyleThumbnailPreview from '@/components-v2/presentation-editor/side-left/FreestyleThumbnailPreview.vue'
import ModalClearDataSlide from '../../modals/ClearDataSlide.vue'
import SlidesUndoRedoUtil from '@/utils/SlidesUndoRedo.util'
import ModalImportSheet from '@/components-v2/modals/ImportSheet.vue'
import LeftNavUpper from './LeftNavUpper.vue'

// trackers
import SlideMixpanelTracker from '@/utils/mixpanel/slide.mixpanel-tracker'
import PresentationMixpanelTracker from '@/utils/mixpanel/presentation.mixpanel-tracker'

import {
  copyBackgroundCacheToSlides,
  copyQuestionImageCacheToSlides,
  copySlideOptionImageCache,
} from '@/utils/indexedDB/image.cache.utils'
import { generateBlockId } from '@/utils/CanvasBlocksLayout'

const { PRESENTATION_EDITOR } = eventCategories
const throttleMs = 150

export default {
  name: 'SideLeft',
  components: {
    draggable,
    SlideTypeIcon,
    SlideCopy,
    SlideCopyV2,
    ModalClearDataSlide,
    ModalImport,
    ModalSlideLimit,
    FreestyleThumbnailPreview,
    ModalImportSheet,
    LeftNavUpper,
    ToolBoxSideLeft,
  },
  mixins: [
    UndoRedoMixin,
    PaymentLocalizationMixin,
  ],
  data() {
    return {
      drag: false,
      showModalLimitSlides: false,
      selectedOrder: null,
      modalUploadPpt: false,
      windowInnerWidth: window.innerWidth,
      selectedSlideIds: [],
      isSelectMode: false,
      isSelectKeyPressed: false,
      isShiftKeyPressed: false,
      isExcutingAction: false,
      bus: new Vue(),
      lastSelectTime: 0,
      lastDeselectTime: 0,
      modalData: {},
      indexSettingSlide: null,
      showModalClearDataSlide: false,
      // showModalSlideDelete: false,
      targetSlide: null,
      targetX: null,
      targetY: null,
      visibleModalCopySlide: false,
      isListeningKeyboardEvents: false,
      gridViewSelectedSlides: [],
      deletedSlides: [],
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isAbTestCollab']),
    ...mapGetters('themeModule', ['canViewThemeGallery', 'defaultThemeValues']),
    ...mapGetters('slideModule', ['slides']),
    ...mapGetters('rightNav', ['rightNavTabNames', 'rightNavActiveTab']),
    ...mapGetters('collaboration', ['isTakeOverToolbarVisible']),
    ...mapGetters('docToSlideGenerator', ['isDocToSlideImportModalVisible']),
    ...mapGetters('featureToggles', ['canUseCopySharedSlides']),
    ...mapGetters('featureToggles', [
      'canMergePickImageIntoPickAnswer',
    ]),
    ...mapGetters('themeModule', [
      'canUseTheme',
      'currentPresentationTheme',
    ]),
    ...mapGetters('history', ['canUseUndoRedoV2']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      showingSlideGrid: (state) => state.indicators.showingSlideGrid,
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      isGuestUser: (state) => state.currentUser.isGuest,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      openModalImportSheet: (state) => state.openModalImportSheet,
      currentUser: (state) => state.currentUser,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      canEditPresentation: (state) => state.canEditPresentation,
      planBenefitLimitation: (state) => state.planBenefitLimitation,
    }),
    isDisableOpenSettingSlide() {
      return this.isDisableEditPresentation || this.isBackstage
    },
    disableAddNew() {
      return !this.canEditPresentation
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'slide-group',
        disabled: false,
        delay: 0,
        delayOnTouchOnly: false,
        ghostClass: 'ghost',
        handle: '.slide-drag',
        multiDrag: true,
        multiDragKey: 'Alt',
        draggable: '.list-group-item',
      }
    },
    noCorrectAnswerTooltip() {
      return {
        content: this.$i18nPresenter.t('You have not selected a correct answer for this Quiz question!'),
        placement: 'top-end',
        boundariesElement: document.body,
      }
    },
    isSelectAll() {
      return this.getActiveOrSelectedSlides().length
       === this.$store.state.presentation.slides.length
    },
    isSmallScreen() {
      return window.innerWidth < 768
    },
    backgroundImage() {
      return (item) => {
        // need enable when finish cache content slide
        // if (item.backgroundCache) return item.backgroundCache
        const extension = item.backgroundImage.name.split('.').pop()
        if (extension === 'gif') {
          return item.backgroundImage.large
        }
        return item.backgroundImage.thumbnail
      }
    },

    isMultipleSlidesSelected() {
      return this.selectedSlideIds && this.selectedSlideIds.length && this.selectedSlideIds.length > 1
    },

    isResetResultsButtonDisabled() {
      return this.isSelectMode || this.isMultipleSlidesSelected
    },
  },
  created() {
    this.clickOutsideSlideList = {
      handler: this.onClickOutsideSlideList,
      middleware: this.clickOutsideMiddleware,
    }
  },
  mounted() {
    const newSlides = this.$store.state.presentation.slides.map((item) => {
      return { ...item, isSlideCopyPopoverShowing: false }
    })

    this.$store.state.presentation.slides = newSlides
    const self = this
    EventBus.$on('addSlideLeaderboard', (data) => {
      self.addSlideLeaderboard(data)
    })

    EventBus.$on('removeSlideLeaderboard', () => {
      self.removeSlideLeaderboard()
    })

    EventBus.$on('slide-search-popup:add-new-slide', () => {
      self.addNewSlide()
    })

    EventBus.$on('ai-generator-modal: add-new-slide', () => {
      self.addNewSlide('AI Quiz Generator')
    })

    EventBus.$on('sortSlidePresentation', () => {
      self.sortSlide()
      self.hideModalUploadPpt()

      if (this.isSelectMode) {
        this.toggleSelectMode()
        this.deselectAllSlides()
      }
    })

    EventBus.$on('openModalLimitSlides', () => {
      this.showModalLimitSlides = true
    })

    EventBus.$on('updateLastSlide', () => {
      this.updateLastSlide()
    })

    EventBus.$on('makeSlideActive', (slide, isDelete, clickSource) => {
      this.makeSlideActive(slide, isDelete, clickSource)
    })

    EventBus.$on('SideLeft: setSelectedSlideIds', (slideIdsArray) => {
      this.selectedSlideIds = slideIdsArray
    })

    EventBus.$on('SideLeft: deselectAllSlides', () => {
      this.deselectAllSlides()
    })

    this.registerHistory()

    if (this.$store.state.isReachLimitSlides) {
      this.showModalLimitSlides = true
    }

    this.listenKeyboardEvents()
    document.addEventListener('keydown', this.onKeyDown)
    document.addEventListener('keyup', this.onKeyUp)

    EventBus.$on('dragBlockContentSlide', () => {
      this.unlistenKeyboardEvents()
    })

    window.onblur = this.exitSelectMode

    // Handle SortableJs uncatched errors
    window.onerror = (msg) => {
      if (msg.indexOf('TypeError:') > -1) {
        this.$store.dispatch('setSyncPresentation', 3)
      }
    }
    // Will be used by the Export PDF server, to screenshot a single slide (instead of all slides)
    window.selectSingleSlideById = this.selectSingleSlideById
  },
  destroyed() {
    EventBus.$off('sortSlidePresentation')
    EventBus.$off('addSlideLeaderboard')
    EventBus.$off('removeSlideLeaderboard')
    EventBus.$off('openModalLimitSlides')
    EventBus.$off('updateLastSlide')
    EventBus.$off('makeSlideActive')
    EventBus.$off('slide-search-popup:add-new-slide')
    EventBus.$off('ai-generator-modal: add-new-slide')
    EventBus.$off('SideLeft: setSelectedSlideIds')
    EventBus.$off('SideLeft: deselectAllSlides')

    document.removeEventListener('keydown', this.onKeyDown)
    document.removeEventListener('keyup', this.onKeyUp)
    this.unlistenKeyboardEvents()
    this.setShowingSlideGridAction(false)
    this.isShiftKeyPressed = false
    this.isSelectKeyPressed = false

    window.onblur = () => {}
    window.onerror = () => {}
  },
  methods: {
    ...mapActions([
      'clearHistory',
      'setShowingSlideGridAction',
      'setSelectedSlideIdsAction',
      'updateSlideActiveAction',
      'setSyncLoadingAction',
      'setSlideActiveAction',
      'getLimitationPresentationAction',
      'updateCurrentUserAction',
      'patchPresentationAction',
    ]),
    ...mapActions('slideRenderHandler', ['setSlideRenderInProgressAction', 'setIsAIIndicatorVisibleAction']),
    ...mapActions('rightNav', ['setRightNavActiveTabAction']),
    ...mapActions('history', ['setSuppressHistoryAction', 'undoSlidesAction']),
    focusNoteAndMakeSlideActive(item) {
      this.deselectAllSlides()
      this.makeSlideActive(item)
      window.setTimeout(() => {
        EventBus.$emit('slide-notes:focus-input')
      }, 200) // makeSlideActive() has a 150ms timeout, so this has to be higher
    },
    openSettingSlide(index, item, event) {
      if (this.isDisableOpenSettingSlide) return
      this.indexSettingSlide = index
      this.targetSlide = item ? { ...item, index } : null

      // Select slide & open context menu in clicked point
      if (event) {
        this.targetX = event.x
        this.targetY = event.y
        this.deselectAllSlides()

        // Check for active slide first to prevent reload
        if (this.$store.state.slideActive.id !== item.id) {
          this.makeSlideActive(item)
        }
      } else {
        this.targetX = null
        this.targetY = null
      }
      this.$refs['aha-context-menu'].show()
    },
    hideSettingSlide() {
      this.indexSettingSlide = null
      this.targeSlide = null
    },
    getSlideBgSize(bgSize) {
      if (!bgSize) return 'bg-cover'
      return 'bg-contain'
    },
    isSlideSelected(slide) {
      return this.selectedSlideIds.some((id) => id && slide.id === id)
    },

    exitSelectMode() {
      setTimeout(() => {
        this.isSelectKeyPressed = false
        this.isSelectMode = false
        document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Alt' }))
      })
    },

    toggleSelectMode() {
      this.isSelectMode = !this.isSelectMode
      if (this.isSelectMode) {
        this.cleanNewSlides()
        if (this.selectedSlideIds.length === 0) {
          this.selectSlides([this.$store.state.slideActive.id])
        }
        setTimeout(() => {
          document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Alt' }))
          this.isSelectKeyPressed = true
        })
      } else {
        setTimeout(() => {
          document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Alt' }))
          this.isSelectKeyPressed = false
        })
      }

      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        this.isSelectMode
          ? 'Grid Menu > Click Select…'
          : 'Grid Menu > Click Done',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },

    clickOutsideMiddleware(e) {
      return !e.target.closest('.left-nav-upper__wrapper')
    },

    // clickSlideLeft() {
    //   this.listenKeyboardEvents()
    // },
    onClickOutsideSlideList() {
      this.unlistenKeyboardEvents()
    },

    listenKeyboardEvents() {
      if (this.isListeningKeyboardEvents) {
        return
      }
      document.addEventListener('keydown', this.keyDownHandlerForSlideList)
      this.isListeningKeyboardEvents = true
    },

    unlistenKeyboardEvents() {
      if (!this.isListeningKeyboardEvents) {
        return
      }
      document.removeEventListener('keydown', this.keyDownHandlerForSlideList)
      this.isListeningKeyboardEvents = false
    },

    keyDownHandlerForSlideList(evt) {
      if (evt.target.nodeName === 'INPUT' || evt.target.nodeName === 'TEXTAREA') {
        return
      }

      if (evt && evt.code === 'KeyD' && (evt.ctrlKey || evt.metaKey)) {
        evt.preventDefault()
        Vue.toasted.clear()
        this.duplicateSlidesByShortKey()
      }

      if (evt && (evt.key === 'Backspace' || evt.key === 'Delete') && this.canEditPresentation) {
        Vue.toasted.clear()
        this.deleteSlidesByShortKey()
      }
    },
    deleteSlidesByShortKey() {
      if (this.isExcutingAction) return
      const toBeDeletedSlides = this.getActiveOrSelectedSlides()
      this.handleDeleteSlides(toBeDeletedSlides)
      Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Delete slides by keyboard', null, null, {
        slideId: toBeDeletedSlides.filter((i) => i.id != null).map((i) => i.id).join(','),
        presentationId: this.presentation.id,
      })
    },

    async duplicateSlidesByShortKey() {
      const selectedSlides = this.getActiveOrSelectedSlides()
      const maxIndex = Math.max(...selectedSlides
        .map((slide) => this.$store.state.presentation.slides.findIndex((s) => s.id === slide.id)))
      if (selectedSlides.length > 0) {
        await this.duplicateSlides(selectedSlides, maxIndex)
        this.updateLastSlide()
        selectedSlides.forEach((item) => {
          Util.mixpanelTracking(
            PRESENTATION_EDITOR,
            'Slide Actions > Duplicate button',
            'Short key',
            item.id,
            {
              slideType: item.type,
            },
          )
        })
      }
    },

    onKeyDown(evt) {
      // Trigger Alt for both Control & Meta key,
      // so we can use Control/Command & Alt/Option to select
      const isFocusingOnAnInput = document.activeElement && document.activeElement.nodeName === 'INPUT'
      if (isFocusingOnAnInput) return
      if (evt && (evt.key === 'Control' || evt.key === 'Meta')) {
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Alt' }))
        this.isSelectKeyPressed = true
      }

      // Exit select mode if using tab
      if (evt && (evt.key === 'Tab')) {
        this.exitSelectMode()
      }

      if (evt && (evt.key === 'Shift')) {
        this.isShiftKeyPressed = true
      }
    },

    onKeyUp(evt) {
      if (evt && (evt.key === 'Control' || evt.key === 'Meta')) {
        document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Alt' }))
        this.isSelectKeyPressed = false

        if (this.isSelectMode) {
          this.toggleSelectMode()
        }
      }

      if (evt && (evt.key === 'Shift')) {
        this.isShiftKeyPressed = false
      }
    },

    openSlideGrid() {
      this.setShowingSlideGridAction(true)
      Util.mixpanelTracking(PRESENTATION_EDITOR, 'Left Sidebar > Click open slide grid', `Presentation: ${this.$store.state.presentation.id}`)
    },

    closeSlideGrid() {
      this.setShowingSlideGridAction(false)
      if (this.isSelectMode) {
        this.toggleSelectMode()
      }
    },

    cleanNewSlides() {
      this.$store.state.presentation = {
        ...this.$store.state.presentation,
        slides: this.$store.state.presentation.slides.filter((slide) => !!slide.id),
      }
      this.selectedSlideIds = this.selectedSlideIds.filter((id) => !!id)
    },

    onDragStart() {
      if (this.isBackstage) return
      this.drag = true
    },

    onDragEnd() {
      if (this.isBackstage) return
      this.drag = false
    },

    selectToDrag(evt, notUpdateActive) {
      // Too fast, not human
      if (this.isSelectKeyPressed && !notUpdateActive) {
        this.lastSelectTime = Date.now()
        if (this.lastSelectTime - this.lastDeselectTime < throttleMs) {
          this.callDeselect(evt.item, true)
          return
        }
      }

      // Prevent switching slide when uploading image is in progress
      if (this.$store.state.imageUploading) {
        Util.showToastError(this.$i18nPresenter.t('Image upload is in progress, please wait until it is finished!'))
        return
      }

      const slideId = this.getSlideIdFromEvt(evt)
      if (!this.selectedSlideIds.some((id) => id === slideId)) {
        this.selectedSlideIds.push(slideId)
      }

      if (!slideId && evt && evt.item) {
        const index = parseInt(evt.item.getAttribute('data-index'), 10)
        if (index > -1) {
          this.makeSlideActive(this.$store.state.presentation.slides[index])
        }
      }

      if (this.selectedSlideIds.length > 1) {
        this.cleanNewSlides()
      }

      if (!notUpdateActive) {
        // If not in multiple select mode, select only one
        if (!this.isSelectKeyPressed && !this.isShiftKeyPressed) {
          const slide = this.$store.state.presentation.slides
            .find((s) => s.id === slideId)

          if (slide) {
            this.deselectAllSlides()
            if (this.slideActive.id !== slideId) {
              this.makeSlideActive(slide)
            }
          }
        } else {
          const activeId = this.$store.state.slideActive.id
          const activeSlideNotInSelected = !this.selectedSlideIds
            .some((id) => id === activeId)

          this.activeSlideDetail(false)

          // If active slide is not in selected slides any more, active new one
          if (activeSlideNotInSelected) {
            if (this.isSelectKeyPressed) {
              this.selectSlides([activeId])
            } else {
              const firstSlideId = this.selectedSlideIds[0]
              const firstSlideIndex = this.$store.state.presentation.slides
                .findIndex((s) => s.id === firstSlideId)
              this.makeSlideActive(this.$store.state.presentation.slides[firstSlideIndex])
            }
          }
        }
      }
      this.setSelectedSlideIdsAction(this.selectedSlideIds)
      this.listenKeyboardEvents()
    },

    deselectToDrag(evt, notUpdateActive) {
      // Too fast, not human
      if (this.isSelectKeyPressed && !notUpdateActive) {
        this.lastDeselectTime = Date.now()
        if (this.lastDeselectTime - this.lastSelectTime < throttleMs) {
          this.callSelect(evt.item, true)
          return
        }
      }

      const slideId = this.getSlideIdFromEvt(evt)
      const index = this.selectedSlideIds.findIndex((id) => id === slideId)
      if (index > -1) {
        this.selectedSlideIds.splice(index, 1)
      }
      this.setSelectedSlideIdsAction(this.selectedSlideIds)

      if (!notUpdateActive) {
        const slideActiveId = this.$store.state.slideActive.id
        if (this.isSelectKeyPressed && slideId === slideActiveId && this.selectedSlideIds.length) {
          const newActive = this.$store.getters.selectedSlides
            .filter((slide) => slide.id !== slideActiveId)[0]
          if (newActive && newActive.id) {
            this.makeSlideActive(newActive)
          }
        }
      }
    },
    getSlideIdFromEvt(evt) {
      if (!evt.item || !evt.item.id) {
        return null
      }

      const [, slideId] = evt.item.id.split('-')
      return parseInt(slideId, 10) || null
    },

    closeSlideCopyPopover() {
      const newSlides = this.$store.state.presentation.slides.map((item) => {
        return { ...item, isSlideCopyPopoverShowing: false }
      })

      this.$store.state.presentation.slides = newSlides
    },

    handleCopyIconClick(slide) {
      if (this.isGuestUser) return

      this.targetSlide = slide
      this.visibleModalCopySlide = true
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Slide Actions > Copy Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
      this.handleCopySlides(slide, true)
      this.hideSettingSlide()
    },

    copySlidesTo() {
      this.targetSlide = null
      this.visibleModalCopySlide = true
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        // eslint-disable-next-line max-lines
        'Grid Menu > Copy Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()

      // eslint-disable-next-line max-lines
      if (selectedSlides.length === 1 && !selectedSlides[0].id) {
        return
      }

      const lastSelected = selectedSlides[selectedSlides.length - 1]
      this.handleCopySlides(lastSelected, false)
    },

    handleCopySlides(slide, copySingleSlide) {
      const { isSlideCopyPopoverShowing } = slide
      const newSlides = this.$store.state.presentation.slides.map((item) => {
        if (item.id === slide.id) {
          return { ...item, isSlideCopyPopoverShowing: !isSlideCopyPopoverShowing, copySingleSlide }
        }

        return { ...item, isSlideCopyPopoverShowing: false, copySingleSlide: false }
      })

      this.$store.state.presentation.slides = newSlides
      this.visibleModalCopySlide = true
    },

    hideModalUploadPpt() {
      this.$store.state.openImportModal = false
    },

    removeSlideLeaderboard() {
      this.deselectAllSlides()
      const index = Util.getIndexSlide(
        this.$store.state.presentation.slides,
        this.$store.state.slideActive.id,
      )
      const { id } = this.$store.state.presentation.slides[index + 1]
      this.$store.state.presentation.slides.splice(index + 1, 1)
      this.$store.dispatch('setSyncPresentation', 1)
      this.$http
        .put(Config.api.updateSlide + id, {
          deleted: true,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
          presenting: this.$store.getters.isPresenting,
        })
        .then(
          () => {
            this.$store.dispatch('setSyncPresentation', 2)
            this.updateLastSlide()
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    activeSlideDetail(isDelete) {
      if (this.isSmallScreen && isDelete) {
        this.$store.state.activeModelDetailSlide = false
      } else {
        this.$store.state.activeModelDetailSlide = true
      }
    },

    resetContentSlideToolbar() {
      EventBus.$emit('show-freestyle-editor-toolbar', false)
      this.$store.state.selectingBlocks = []
    },

    _setRightNavActiveTab(tabName) {
      if (!this.rightNavActiveTab || !this.rightNavActiveTab.length) return
      this.setRightNavActiveTabAction(tabName)
    },

    makeSlideActive(item, isDelete, clickSource) {
      this.$store.state.controllerSocketId = Socket.getSocketId()
      if (!item) return
      this.activeSlideDetail(isDelete)
      this.resetContentSlideToolbar()
      this.setIsAIIndicatorVisibleAction(item)

      // Prevent multi-select on mobile
      if (this.isSmallScreen) {
        this.deselectAllSlides()
      }
      if (item.type === 'pickAnswer') {
        item.hideResult = false
        item.showCorrectOption = false
      }
      if (item.id) {
        setTimeout(() => {
          this.setSlideActiveAction(item)
          EventBus.$emit('slide-search-popup:close')
          this.setSlideRenderInProgressAction(true) // Forces Slide component re-render on slideActive change
          if (clickSource === 'report') {
            const container = this.$refs.leftScrollBar
            const el = document.getElementById(`slide-${item.id}`)
            if (container && el) {
              container.scrollTop = el.offsetTop - container.offsetTop
            }
          }
          EventBus.$emit('eventHandleSetValueTransition')
          this._setRightNavActiveTab(this.rightNavTabNames.CONTENT)
        }, 100)
      } else {
        this.setSlideActiveAction(item)
        EventBus.$emit('eventHandleSetValueTransition')
      }
      if (!item.id) {
        this.openSlideSearchPopup()
        this._setRightNavActiveTab(this.rightNavTabNames.CONTENT)
        return
      }

      // Select active, too
      if (!this.selectedSlideIds.some((id) => id === item.id)) {
        this.selectSlides([item.id])
      }

      EventBus.$emit('updateNextSlide', item.id, clickSource)

      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Select Slide > Make Active',
        `Presentation: ${this.$store.state.presentation.id}`,
        null,
        {
          slideId: item.id,
          convertedFromDocument: item.type === 'freestyle' && item.image !== null,
        },
      )
    },

    _createSlideLeaderboard(item, cb) {
      this.$http
        .post(Config.api.createSlide, {
          presentationId: this.$store.state.presentation.id,
          type: item.type,
          order: item.order,
          socketId: Socket.getSocketId(),
          textColour: item.textColour,
          baseColour: item.baseColour,
          backgroundImage: item.backgroundImage,
          visibility: item.visibility,
        })
        .then((res) => {
          item.id = res.body.id
          cb(item)
        })
        .catch((error) => {
          Util.handleError(error.body.message)
        })
    },

    addSlideLeaderboard(data) {
      this.deselectAllSlides()
      const { slideActive } = this.$store.state
      const _sortSlide = () => {
        this.$store.state.presentation.slides.forEach((item, key) => {
          item.order = key + 1
        })
      }
      const _newOrder = (index) => {
        for (let i = 0; i < this.$store.state.presentation.slides.length; i++) {
          if (i > index) {
            this.$store.state.presentation.slides[i].order = i + 2
          }
        }
        this.$store.state.presentation.slides.push()
      }
      let index = this.$store.state.presentation.slides
        .findIndex((item) => item.id === this.$store.state.slideActive.id)
      if (data && data.lastSlide) {
        for (let i = 0; i < this.$store.state.presentation.slides.length; i++) {
          if (this.$store.state.presentation.slides[i].type === 'pickAnswer') {
            index = i
          }
        }
      }
      if (
        index === -1
        || this.$store.state.presentation.slides.length - 1 === index
      ) {
        const slide = {
          index: this.$store.state.presentation.slides.length,
          order: this.$store.state.presentation.slides.length + 1,
          typeObj: {
            type: 'leaderboard',
            name: 'Leaderboard',
          },
          type: 'leaderboard',
          audioShowControl: true,
          audioAudienceShowControl: true,
          backgroundCache: slideActive.backgroundCache,
          cropperDataCache: slideActive.cropperDataCache,
          originBackgroundCache: slideActive.originBackgroundCache,
          ...this.defaultThemeValues,
        }

        this._createSlideLeaderboard(slide, (data) => {
          if (slideActive.backgroundCache) {
            copyBackgroundCacheToSlides(slideActive, [data])
          }
          this.$store.state.presentation.slides.push(data)
          EventBus.$emit('slide-generator:unlock-add-slide')
          setTimeout(() => {
            const container = this.$refs.leftScrollBar
            container.scrollTop = container.scrollHeight
          }, 200)

          this.sortSlide()
        })

        _sortSlide()
      } else {
        const slide = {
          order: index + 2,
          typeObj: {
            type: 'leaderboard',
            name: 'Leaderboard',
          },
          type: 'leaderboard',
          backgroundCache: slideActive.backgroundCache,
          cropperDataCache: slideActive.cropperDataCache,
          originBackgroundCache: slideActive.originBackgroundCache,
          ...this.defaultThemeValues,
        }
        _sortSlide()
        _newOrder(index)
        this._createSlideLeaderboard(slide, (data) => {
          if (slideActive.backgroundCache) {
            copyBackgroundCacheToSlides(slideActive, [data])
          }
          this.$store.state.presentation.slides.splice(index + 1, 0, data)
          EventBus.$emit('slide-generator:unlock-add-slide')
          this.sortSlide()
        })
      }
      Util.mixpanelTracking(
        'Presentation Editing',
        'New slide leaderboard',
        'Auto add leaderboard',
      )
    },

    applyDefaultStyleToSlide(
      defaultBlack = DEFAULT_THEME_ATTRIBUTES.textColour,
      defaultWhite = DEFAULT_THEME_ATTRIBUTES.baseColour,
      sampleSlide,
    ) {
      if (this.canViewThemeGallery) {
        return {
          id: null,
          timestamp: new Date().getTime(),
        }
      }
      return {
        id: null,
        textColour: sampleSlide.textColour || defaultBlack,
        baseColour: sampleSlide.baseColour || defaultWhite,
        backgroundImage: sampleSlide.backgroundImage,
        visibility: sampleSlide.visibility,
        timestamp: new Date().getTime(),
        backgroundCache: sampleSlide.backgroundCache,
        cropperDataCache: sampleSlide.cropperDataCache,
        originBackgroundCache: sampleSlide.originBackgroundCache,
      }
    },

    addNewSlide(label = 'Click on New Slide button', focusedIndex = null) {
      if (this.disableAddNew) return
      if (this._isReachLimitSlides()) return
      this.deselectAllSlides()
      const { slideActive } = this.$store.state
      const defaultBlack = DEFAULT_THEME_ATTRIBUTES.textColour
      const defaultWhite = DEFAULT_THEME_ATTRIBUTES.baseColour
      const _sortSlide = () => {
        this.$store.state.presentation.slides.forEach((item, key) => {
          item.order = key + 1
        })
      }
      let index
      let sampleSlide

      if (focusedIndex !== null) {
        index = focusedIndex === -1 ? this.presentation.slides.length - 1 : focusedIndex
        sampleSlide = this.presentation.slides[index]
      } else {
        index = this.$store.state.presentation.slides.findIndex((item) => item.id === slideActive.id)
        sampleSlide = this.slideActive
      }
      sampleSlide = this.canUseTheme ? this.currentPresentationTheme : sampleSlide
      const slide = this.applyDefaultStyleToSlide(defaultBlack, defaultWhite, sampleSlide)
      if (
        index === -1
        || this.$store.state.presentation.slides.length - 1 == index
      ) {
        slide.index = this.$store.state.presentation.slides.length
        slide.order = this.$store.state.presentation.slides.length + 1
        this.$store.state.presentation.slides.push(slide)
        this.makeSlideActive(slide)
        _sortSlide()
      } else if (
        this.$store.state.presentation.slides[index + 1].type
            === 'leaderboard'
          && this.$store.state.slideActive.type === 'pickAnswer'
      ) {
        slide.order = index + 3
        _sortSlide()
        this.$store.state.presentation.slides.splice(index + 2, 0, slide)
        this.makeSlideActive(slide)
      } else {
        slide.order = index + 2
        _sortSlide()
        this.$store.state.presentation.slides.splice(index + 1, 0, slide)
        this.makeSlideActive(slide)
      }
      setTimeout(() => {
        const container = this.$refs.leftScrollBar
        const newActiveSlide = document.getElementsByClassName('active-slide')[0]
        if (!newActiveSlide) return
        Util.scrollToElement(container, {
          behavior: 'smooth',
          top: newActiveSlide.offsetTop - 200,
        })
      }, 200)

      this.sortSlide()
      Util.mixpanelTracking(
        'Presentation Editing',
        'New slide',
        label,
      )
      this.openSlideSearchPopup()
      if (!this.rightNavActiveTab) {
        this.setRightNavActiveTabAction(this.rightNavTabNames.CONTENT)
      }
      if (this.$store.state.isEnableAddinPowerpoint) {
        this.$store.state.isOpenEditSlidePowerPoint = true
      }
    },

    selectSingleSlideById(slideId) {
      const index = this.$store.state.presentation.slides.findIndex((item) => item.id === slideId)
      if (index !== -1) {
        const slide = this.$store.state.presentation.slides[index]
        this.makeSlideActive(slide)
      }
    },

    openSlideSearchPopup() {
      const { indicators } = this.$store.state
      if (indicators.showingSlideGrid) return

      EventBus.$emit('slide-search-popup:open')
    },

    async handleDragAndDropSlide(event) {
      if (this.isBackstage) return
      this.setSuppressHistoryAction(true)
      const { slides } = this.$store.state.presentation
      this.selectedSlideIds = []

      if (slides.length < 2 || !event || !event.moved) return

      let moved = []
      if (Array.isArray(event.moved)) {
        if (!event.moved) {
          return
        }

        moved = event.moved
          .map((e) => ({
            id: e.element.id,
            order: e.element.order,
            oldIndex: e.oldIndex,
            newIndex: e.newIndex,
          }))
      } else {
        if (!event.moved.element) {
          return
        }

        moved = [{
          id: event.moved.element.id,
          order: event.moved.element.order,
          oldIndex: event.moved.oldIndex,
          newIndex: event.moved.newIndex,
        }]
      }

      const movedSlides = this.calculateSlideOrderMultiple(slides, moved)
      const movedSlidesMap = movedSlides
        .map((s) => ({ [s.id]: s.order }))
        .reduce((a, b) => ({ ...a, ...b }), {})

      // Update back to slides
      moved.forEach((slide) => {
        if (this.$store.state.presentation.slides[slide.newIndex]) {
          this.$store.state.presentation.slides[slide.newIndex].order = movedSlidesMap[slide.id]
        }
      })

      // Make first slide active
      this.makeSlideActive(this.$store.state.presentation.slides[moved[0].newIndex])

      try {
        this.$store.dispatch('setSyncPresentation', 1)

        await SlideApi.updateSlides({
          socketId: Socket.getSocketId(),
          presentationId: this.$store.state.presentation.id,
          slides: movedSlides,
        })

        EventBus.$emit('sort-slide')
        this.updateLastSlide()

        this.$store.dispatch('setSyncPresentation', 2)
        Util.mixpanelTracking(PRESENTATION_EDITOR, 'Left Sidebar > Drag slides success', `Moved slides: ${moved.length}`)
      } catch (error) {
        Sentry.captureException(error)
        this.$store.dispatch('setSyncPresentation', 3)
        const msg = moved.length > 1 ?
          `${this.$i18nPresenter.t('failToRearrangeSlide', {
            length: moved.length,
          })}` :
          `${this.$i18nPresenter.t('failToRearrangeSlides', {
            length: moved.length,
          })}`
        Util.showToastError(msg)
        Util.mixpanelTracking(PRESENTATION_EDITOR, 'Left Sidebar > Drag slides error', `Error: ${JSON.stringify(error)}`)
      }

      this.deselectAllSlides()
      this.setSuppressHistoryAction(false)
    },

    calculateSlideOrderMultiple(slides, moved) {
      // Use fraction instead of average for calculate the order in between
      const indexBefore = moved[0].newIndex - 1
      const indexAfter = moved[moved.length - 1].newIndex + 1

      let nBefore = 0
      let dBefore = 1
      if (indexBefore >= 0) {
        const fBefore = new Fraction(slides[indexBefore].order)
        nBefore = fBefore.n
        dBefore = fBefore.d
      }

      let nAfter = slides.length
      let dAfter = 0
      if (indexAfter < slides.length) {
        const fAfter = new Fraction(slides[indexAfter].order)
        nAfter = fAfter.n
        dAfter = fAfter.d
      }

      return moved
        .map((s) => {
          const order = new Fraction(nBefore + nAfter, dBefore + dAfter)
          nBefore = order.n
          dBefore = order.d
          return { id: s.id, order: order.valueOf() }
        })
    },

    sortSlide() {
      const sort = []
      this.$store.state.presentation.slides.forEach((item, key) => {
        item.order = key + 1
        if (item.id) {
          sort.push({
            order: key + 1,
            id: item.id,
          })
        }
      })

      if (!sort.length || this.$store.state.isAdmin) return
      this.$store.dispatch('setSyncPresentation', 1)
      this.$http
        .put(Config.api.sortSlide + this.$store.state.presentation.id, {
          sort,
          accessCode: this.$store.state.presentation.uniqueAccessCode,
          socketId: Socket.getSocketId(),
        })
        .then(
          () => {
            this.$store.dispatch('setSyncPresentation', 2)
            this.updateLastSlide()
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    updateLastSlide() {
      const idLastSlide = Util.getLastSlide(this.$store.state.presentation.slides)
      const payload = {
        socketId: Socket.getSocketId(),
      }
      if (idLastSlide && idLastSlide != this.$store.state.presentation.lastSlide) {
        payload.lastSlide = idLastSlide
        this.$store.state.presentation.lastSlide = idLastSlide
        this.$http.put(
          Config.api.updatePresentation + this.$store.state.presentation.id,
          payload,
        ).then(() => {}, () => {})
      }
    },

    clearSingleSlide(item) {
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Slide Actions > Erase Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
      this.clearSlidesConfirm([item])
      this.hideSettingSlide()
    },

    clearSelectedSlides() {
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Grid Menu > Erase Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()
      this.clearSlidesConfirm(selectedSlides)
    },

    async undoDuplicateSlides(data) {
      await SlidesUndoRedoUtil.undoDuplicateSlides(this, data)
    },

    async redoDuplicateSlides(data) {
      await SlidesUndoRedoUtil.redoDuplicateSlides(this, data)
    },

    async undoDeleteSlides(data) {
      await SlidesUndoRedoUtil.undoDeleteSlides(this, data)
    },

    async redoDeleteSlides(data) {
      await SlidesUndoRedoUtil.redoDeleteSlides(this, data)
    },

    async deleteSingleSlide(item) {
      await this.handleDeleteSlides([item])
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Slide Actions > Delete Button',
        null,
        null,
        {
          presentationId: this.presentation.id,
          slideId: item.id,
        },
      )
    },

    async undoCreateSlide(data) {
      await SlidesUndoRedoUtil.undoCreateSlide(this, data)
    },

    async redoCreateSlide(data) {
      await SlidesUndoRedoUtil.redoCreateSlide(this, data)
    },

    deleteSelectedSlides() {
      if (this.isExcutingAction) return
      const selectedSlides = this.getActiveOrSelectedSlides()
      this.handleDeleteSlides(selectedSlides)
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Grid Menu > Delete Button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },

    async handleDeleteSlides(toBeDeletedSlides) {
      this.isExcutingAction = true
      try {
        const oldSlides = JSON.parse(JSON.stringify(this.presentation.slides))
        if (!toBeDeletedSlides || toBeDeletedSlides.length === 0) { return }

        toBeDeletedSlides.forEach((s) => {
          s.index = this.presentation.slides.findIndex(
            (pslide) => s.id === pslide.id,
          )
        })

        toBeDeletedSlides.forEach((s) => {
          this.addQuizAndLeaderboardToSlidesToDelete(toBeDeletedSlides, s)
        })
        const newSlides = oldSlides.filter((s) => !toBeDeletedSlides.find((slide) => slide.id === s.id))

        await this.handleCallAPIDeleteSlides(toBeDeletedSlides)
        const payload = SlidesUndoRedoUtil.backupDeletedSlides(this, oldSlides, newSlides, toBeDeletedSlides)
        const toastContent = toBeDeletedSlides.length == 1 ? this.$i18nPresenter.t('1 slide deleted') : `${toBeDeletedSlides.length} ${this.$i18nPresenter.t('slides deleted')}`
        if (toBeDeletedSlides.length < this.presentation.slides.length) {
          Util.showToastSuccess(toastContent, null, {
            text: 'Undo',
            class: 'toast-action-text',
            onClick: (e, toastObject) => {
              if (this.canUseUndoRedoV2) {
                this.undoSlidesAction()
              } else {
                SlidesUndoRedoUtil.undoDeleteSlides(this, payload.data)
              }

              toastObject.goAway(0)
              Util.mixpanelTracking(
                PRESENTATION_EDITOR,
                'Undo Delete Slides > Click on toast',
                null,
                null,
                {
                  presentationId: this.presentation.id,
                  slideId: toBeDeletedSlides.map((s) => s.id).join(', '),
                },
              )
            },
          }, {
            duration: 10e3,
            position: 'bottom-left',
          })
        }
        this.getLimitationPresentationAction(this.presentation.id)
      } catch (err) {
        Sentry.captureException(new Error('Catch handleDeleteSlides > SideLeft'), {
          extra: {
            error: err,
          },
        })
      }
      this.isExcutingAction = false
    },

    addQuizAndLeaderboardToSlidesToDelete(deletedSlides, currentSlide) {
      const sortedSlides = this.presentation.slides.sort((a, b) => a.order - b.order)
      const quizSlides = this.presentation.slides.filter((slide) => slide.type === 'pickAnswer')
      const deletedQuizSlides = deletedSlides.filter((slide) => slide.type === 'pickAnswer')
      let nextSlide = null
      let isNextSlideLastSlide = false

      for (let i = 0; i < sortedSlides.length - 1; i++) {
        if (sortedSlides[i].id === currentSlide.id) {
          nextSlide = sortedSlides[i + 1]
          isNextSlideLastSlide = i + 1 === sortedSlides.length - 1
        }
      }

      if (currentSlide.type === 'pickAnswer' && nextSlide && nextSlide.type === 'leaderboard') {
        // dont remove last leaderboard slide if there is quiz left in the presentation
        if (isNextSlideLastSlide && quizSlides.length !== deletedQuizSlides.length) {
          return
        }

        if (deletedSlides.map((i) => i.id).indexOf(nextSlide.id) !== -1) {
          return
        }

        deletedSlides.push(nextSlide)
      }
    },

    async handleCallAPIDeleteSlides(slides) {
      // filter slide with no id because new slide dont have id
      const slidesWithId = this.presentation.slides.filter((slide) => slide.id)
      if (slides.length === slidesWithId.length) {
        Util.showToastError(this.$i18nPresenter.t('Cannot delete all slides. Please keep at least one.'), null, null, {
          duration: 5e3,
          position: 'bottom-left',
        })
        return
      }

      try {
        this.setSyncLoadingAction(1)

        const apiResponse = await SlideApi.updateSlides({
          presentationId: this.$route.params.id,
          socketId: Socket.getSocketId(),
          slides: slides.map((s) => ({ id: s.id, deleted: true, oldOrder: s.order })),
        })
        OpenAIUtils.setAISlideCountForTracking(apiResponse.body.updatedAISlideCount, this)
        this.updateLocalData(slides)
        this.handleActiveSlideAfterDelete(slides)

        this.setSyncLoadingAction(2)
      } catch (err) {
        Sentry.captureException(err)
        this.setSyncLoadingAction(3)
        const msg = `${this.$i18nPresenter.t('failToDeleteSlides', {
          length: slides.length,
        })}`
        Util.showToastError(msg)
        throw err
      }
    },

    updateLocalData(slides) {
      slides.forEach((s) => {
        const index = this.presentation.slides.findIndex((i) => s.id === i.id)
        this.presentation.slides.splice(index, 1)
      })
      PresentationUtils.checkAndUpdatePresentationHasResults()

      EventBus.$emit('updateLastSlide')
    },

    handleActiveSlideAfterDelete(deletedSlides) {
      setTimeout(() => {
        this.deselectAllSlides()
        const activeIndex = this.presentation.slides.findIndex(
          (s) => s.id === this.slideActive.id,
        )
        if (activeIndex > -1) {
          this.makeSlideActive(
            this.presentation.slides[
              activeIndex ? activeIndex - 1 : activeIndex
            ],
            true,
          )
        } else {
          const slideIndexArray = deletedSlides.map((s) => s.index)
          const minIndex = Math.min(...slideIndexArray) ?
            Math.min(...slideIndexArray) : slideIndexArray[0]
          this.makeSlideActive(
            this.presentation.slides[minIndex ? minIndex - 1 : minIndex],
            true,
          )
        }
      })
    },

    clearSlidesConfirm(slides) {
      this.gridViewSelectedSlides = slides
      if (slides.length && (!slides[0] || !slides[0].id)) {
        return
      }
      this.showModalClearDataSlide = true
    },

    // deleteSlidesConfirm(slides) {
    //   if (slides.length && (!slides[0] || !slides[0].id)) {
    //     this.handleDeleteEmptySlidesInstantly()
    //     return
    //   }

    //   const title = slides.length === 1
    //     ? 'Are you sure that you want to delete this slide?'
    //     : `Are you sure that you want to delete these ${slides.length} slides?`
    //   const content = slides.length === 1
    //     ? 'This slide and any response data will be lost.'
    //     : 'These slides and any response data will be lost.'
    //   this.modalData = {
    //     slides,
    //     title,
    //     content,
    //   }
    //   this.showModalSlideDelete = true
    // },

    // handleCloseModalDeleteSlide() {
    //   this.showModalSlideDelete = false
    //   Util.mixpanelTracking(
    //     eventCategories.PRESENTATION_EDITOR,
    //     'Modal delete slide > Close modal',
    //   )
    // },

    handleCloseModalClearDataSlide() {
      this.showModalClearDataSlide = false
      Util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Modal clear data slide > Close modal',
      )
    },

    handleDeleteEmptySlidesInstantly() {
      const index = this.presentation.slides.findIndex((s) => !s.id)
      this.presentation.slides.splice(index, 1)
      setTimeout(() => {
        this.makeSlideActive(
          this.presentation.slides[index ? index - 1 : index],
          true,
        )
      }, 100)
    },

    getActiveOrSelectedSlides() {
      const { slides } = this.$store.state.presentation
      if (!slides) return []
      slides.forEach((slide, index) => {
        slide.index = index
      })
      const selectedIds = this.selectedSlideIds.length
        ? this.selectedSlideIds
        : [this.$store.state.slideActive.id]
      return selectedIds
        .map((id) => this.$store.state.presentation.slides.find((s) => s.id === (id || null)))
        .sort((a, b) => a.order - b.order)
    },

    async duplicateSelectedSlides() {
      const selectedSlides = this.getActiveOrSelectedSlides()
      const maxIndex = Math.max(...selectedSlides
        .map((slide) => this.$store.state.presentation.slides.findIndex((s) => s.id === slide.id)))
      await this.duplicateSlides(selectedSlides, maxIndex)
      this.updateLastSlide()
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Grid Menu > Duplicate button',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
    },
    messageLimitDuplicateSlides(slide) {
      const message = slide.isForPairPlan ? this.$i18nPresenter.t("You've reached the maximum number of questions for the Free Plan.") :
        this.$i18nPresenter.t("You've reached the maximum number of questions for the Free Plan.")
      Util.showToastError(message)
    },

    async duplicateSingleSlide(item, index) {
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Slide Actions > Duplicate button',
        'Click duplicate',
        item.id,
        {
          slideType: item.type,
        },
      )
      if (this.isForPairPlan(item)) {
        this.messageLimitDuplicateSlides(item)
        return
      }
      await this.duplicateSlides([item], index)
      this.hideSettingSlide()
      this.updateLastSlide()
      this.getLimitationPresentationAction(this.presentation.id)
    },

    _createNewCanvasBlocksForDuplicatedSlide(oldSlide, newSlide) {
      const oldCanvasBlocks = JSON.parse(JSON.stringify(oldSlide.canvasBlocks))
      try {
        const newSlideId = newSlide.id
        const newCanvasBlocks = {}
        Object.keys(oldCanvasBlocks).forEach((oldKey) => {
          // Replace the old slide ID in the key with the new slide ID
          const newBlockId = generateBlockId(newSlideId)

          // Deep clone the original block
          const block = JSON.parse(JSON.stringify(oldCanvasBlocks[oldKey]))

          // Replace the old slide ID in the `id` property of the block
          block.id = newBlockId

          // Add the modified block to the new canvas blocks object
          newCanvasBlocks[newBlockId] = block
        })
        return newCanvasBlocks
      } catch (error) {
        Sentry.captureException(error)
        return oldCanvasBlocks
      }
    },

    async duplicateSlides(items, index) {
      const slidesBeforeDuplicate = JSON.parse(JSON.stringify(this.presentation.slides))
      if (this._isReachLimitSlides()) return
      const itemsToDuplicate = items.filter((item) => item.id && !item.loading)

      if (this.isForPairPlan(itemsToDuplicate[0])) {
        this.messageLimitDuplicateSlides(itemsToDuplicate[0])
        return
      }
      if (!itemsToDuplicate.length) {
        return
      }

      itemsToDuplicate.forEach((i) => {
        i.loading = true
      })

      try {
        this.$store.dispatch('setSyncPresentation', 1)
        const oldSlides = itemsToDuplicate.sort((a, b) => a.order - b.order)

        const response = await SlideApi.duplicateSlides({
          id: itemsToDuplicate.map((i) => i.id),
          presentationId: parseInt(this.$route.params.id, 10),
          socketId: Socket.getSocketId(),
        })
        const slides = response.body

        let newIndex = index + 1
        slides.forEach((slide, i) => {
          if (this.canMergePickImageIntoPickAnswer &&
            slide.type === Constants.SLIDE_TYPE.PICK_ANSWER && !slide.slideType) {
            slide.slideType = Constants.SLIDE_TYPE.PICK_IMAGE
          }
          if (slide.SlideOptions && slide.SlideOptions.length > 0) {
            slide.SlideOptions.sort((a, b) => a.order - b.order)
            slide.SlideOptions.forEach((slideOption, j) => {
              const originSlideOption = oldSlides[i].SlideOptions[j]
              copySlideOptionImageCache(originSlideOption, slideOption)
            })
          }

          if (slide.hints && slide.hints.length > 0) {
            slide.hints.sort((a, b) => a.order - b.order)
          }

          // Parse some unparsed data
          if (slide.additionalFields) {
            slide.additionalFields = JSON.parse(slide.additionalFields)
          }
          if (slide.otherCorrectQuiz) {
            slide.otherCorrectQuiz = JSON.parse(slide.otherCorrectQuiz)
          } else {
            slide.otherCorrectQuiz = []
          }

          if (oldSlides[i].canvasBlocks) {
            slide.canvasBlocks = this._createNewCanvasBlocksForDuplicatedSlide(oldSlides[i], slide)
          }

          if (oldSlides[i].backgroundCache) {
            copyBackgroundCacheToSlides(oldSlides[i], [slide])
          }
          if (oldSlides[i].image) {
            copyQuestionImageCacheToSlides(oldSlides[i], [slide])
          }

          // Icons & some more
          slide.typeObj = oldSlides[i].typeObj

          this.$store.state.presentation.slides.splice(
            newIndex,
            0,
            slide,
          )
          newIndex += 1
        })

        this.$store.dispatch('setSyncPresentation', 2)
        // Select new slides
        this.$nextTick(() => {
          this.makeSlideActive(this.$store.state.presentation.slides[index + 1], null, 'duplicate')
          this.selectSlides(slides.map((s) => s.id))
        })
        const slidesAfterDuplicate = JSON.parse(JSON.stringify(this.presentation.slides))
        SlidesUndoRedoUtil.backupDuplicateSlides(this, slidesBeforeDuplicate, slidesAfterDuplicate, items, slides)
        this.trackDuplicateSlides(itemsToDuplicate, slides.map((s) => s.id))
      } catch (err) {
        Sentry.captureException(err)
        if (Util.handleError(err.body.message)) {
          this.$store.dispatch('setSyncPresentation', 2)
        } else {
          this.$store.dispatch('setSyncPresentation', 3)
        }
        const msg = itemsToDuplicate.length > 1 ?
          `${this.$i18nPresenter.t('failToDuplicateSlides', {
            length: itemsToDuplicate.length,
          })}` :
          `${this.$i18nPresenter.t('failToDuplicateSlide', {
            length: itemsToDuplicate.length,
          })}`
        Util.showToastError(msg)
      }

      itemsToDuplicate.forEach((i) => {
        i.loading = false
      })
      this.deselectAllSlides()
      this.getLimitationPresentationAction(this.presentation.id)
    },

    trackDuplicateSlides(itemsToDuplicate, newSlideIds) {
      const slideTracker = new SlideMixpanelTracker(this.presentation, this.$route.name)
      const presentationTracker = new PresentationMixpanelTracker(this.presentation)
      slideTracker.setCustomProps({
        ...presentationTracker.getPresentationContext(),
        copiedSlideIds: itemsToDuplicate.map((i) => i.id),
        slideId: newSlideIds,
      })
      slideTracker.trackCreateNewSlide('Side left > Slide menu > Duplicate', this.presentation.id)
    },

    callSelect(item) {
      if (this.drag) {
        return
      }

      const evt = document.createEvent('Event')
      evt.initEvent('select', true, true)
      evt.item = item
      evt.items = []

      if (document.querySelector('.list-group')) {
        document.querySelector('.list-group').dispatchEvent(evt)
      }

      this.bus.$emit('select', item)
      this.selectToDrag(evt, true)
    },

    callDeselect(item) {
      if (this.drag) {
        return
      }

      const evt = document.createEvent('Event')
      evt.initEvent('select', true, true)
      evt.item = item
      evt.items = []
      document.querySelector('.list-group').dispatchEvent(evt)

      this.bus.$emit('deselect', item)
      this.deselectToDrag(evt, true)
    },

    deselectAllSlides() {
      // Trigger mouseup in 0, 0 to deselect all for now
      document.dispatchEvent(new MouseEvent('mouseup', { x: 0, y: 0 }))
      this.selectedSlideIds = []
      this.setSelectedSlideIdsAction([])
    },

    selectSlides(ids) {
      ids
        .map((id) => document.getElementById(`slide-${id}`))
        .map((item) => this.callSelect(item))
    },

    async rearrangeSelectedSlides() {
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Grid Menu > Rearrange Button > Click',
        `Presentation: ${this.$store.state.presentation.id}`,
      )

      const selectedSlides = this.getActiveOrSelectedSlides()
      await this.rearrangeSlides(selectedSlides)
    },

    async rearrangeSingleSlide(slide) {
      Util.mixpanelTracking(
        PRESENTATION_EDITOR,
        'Slide Actions > Rearrange Button > Click',
        `Presentation: ${this.$store.state.presentation.id}`,
      )
      await this.rearrangeSlides(slide)
    },

    async rearrangeSlides(selected) {
      this.$refs['aha-context-menu'].hide()
      const { slides } = this.$store.state.presentation

      if (!selected || slides.length < 2) return

      const toIndex = this.selectedOrder
      this.selectedOrder = -1

      const moved = selected
        .map((s, i) => ({
          id: s.id,
          order: s.order,
          newIndex: toIndex + i,
        }))

      this.deselectAllSlides()

      // Delete old ones
      moved.forEach((slide) => {
        slide.oldIndex = slides.findIndex((s) => s.id === slide.id)
        this.$store.state.presentation.slides.splice(slide.oldIndex, 1)
      })

      // Add new ones
      this.$store.state.presentation.slides.splice(toIndex, 0, ...selected)

      // Calculate order
      const movedSlides = this.calculateSlideOrderMultiple(slides, moved)
      const movedSlidesMap = movedSlides
        .map((s) => ({ [s.id]: s.order }))
        .reduce((a, b) => ({ ...a, ...b }), {})

      // Update back to slides
      moved.forEach((slide) => {
        if (this.$store.state.presentation.slides[slide.newIndex]) {
          this.$store.state.presentation.slides[slide.newIndex].order = movedSlidesMap[slide.id]
        }
      })

      if (moved.find((s) => s.id === this.slideActive.id)) {
        this.updateSlideActiveAction({
          index: moved[0].newIndex,
        })
        this.makeSlideActive(this.presentation.slides[moved[0].newIndex])
      }

      try {
        this.$store.dispatch('setSyncPresentation', 1)

        await SlideApi.updateSlides({
          socketId: Socket.getSocketId(),
          presentationId: this.$store.state.presentation.id,
          slides: movedSlides,
        })

        EventBus.$emit('sort-slide')
        this.updateLastSlide()
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (error) {
        Sentry.captureException(error)
        const msg = moved.length > 1 ?
          `${this.$i18nPresenter.t('failToRearrangeSlides', {
            length: moved.length,
          })}` :
          `${this.$i18nPresenter.t('failToRearrangeSlide', {
            length: moved.length,
          })}`
        Util.showToastError(msg)
        this.$store.dispatch('setSyncPresentation', 3)
      }

      // Call again because we make one active above
      this.deselectAllSlides()
    },

    getActiveSlide(item) {
      if (!item.id) {
        if (item.order
         && item.order === this.$store.state.slideActive.order
         && item.title === this.$store.state.slideActive.title) {
          return true
        }
        return false
      } if (item.id && this.$store.state.slideActive.id == item.id) {
        return true
      }
      return false
    },

    _isReachLimitSlides() {
      if (this.presentation.slides.length >= Config.MAX_NUMBER_OF_SLIDE) {
        this.showModalLimitSlides = true
        this.$store.state.openImportModal = false
        return true
      }
      return false
    },

    hideModalSlideLimit() {
      this.showModalLimitSlides = false
      if (this.$store.state.isReachLimitSlides) {
        this.$store.state.isReachLimitSlides = false
      }
    },
    checkPlanBenefitLimitation(item) {
      if (this.planBenefitLimitation.quiz && item.type === 'pickAnswer') {
        return true
      }
      const questionTypes = ['multipleChoice', 'wordCloud', 'openEnded', 'scale', 'ideas', 'imageChoice']
      if (this.planBenefitLimitation.poll && questionTypes.includes(item.type)) {
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.aha-left-column {
  min-width: 225px;
  box-shadow: 0px 10px 38px 0px #525F7F08;
}
.aha-slide-setting-icon {
  font-size: 0.6rem;
  @apply text-base-70;
}

.left-nav-upper__wrapper {
  @apply border-b border-base-30 flex;
}
.aha-slide-item {
  padding-left: 2.3rem;
  @apply pt-3 pb-3 relative;
  .aha-slide-order {
    left: 16px;
    top: 8px;
    font-size: 11px;
    @apply absolute text-base-90;
  }

  .aha-slide-setting {
    font-size: 9px;
    left: 7px;
    @apply absolute bottom-2 pl-3 pt-3 pr-3 cursor-pointer;

    &:hover {
      .aha-slide-setting-icon {
        @apply text-primary-90;
      }
    }
  }
  .aha-slide-content {
    @apply w-40 rounded relative cursor-pointer flex flex-col;
    height: calc(10rem / 16 * 9);
    box-shadow: 0 0 1px 1px rgb(180, 188, 207);
    &.is-content-slide {
      overflow: hidden;
    }
    .aha-slide-bg-image {
      @apply absolute w-full h-full top-0 left-0 bg-no-repeat bg-center rounded;
    }
    .aha-slide-title {
      @apply pl-2 pr-2 text-xs font-bold min-h-6 relative;
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      overflow: hidden;
      line-height: 0.9rem;
      max-height: 2rem;
      height: 2rem;
    }

    &:hover {
      box-shadow: 0 0 0 2px $primary-color;
    }
  }

  &.leaderboard {
    .aha-slide-title {
      @apply min-h-8;
    }
    .aha-slide-type-icon {
      top: 42px;
    }
  }

  &.create-context-item {
    .aha-slide-content {
      box-shadow: none;
    }
  }
}

.active-slide, .select-slide {
  @apply bg-primary-70;

  .aha-slide-content {
    box-shadow: 0 0 0 2px #1279e0;
  }

  .aha-slide-order {
    @apply text-primary-100 font-bold;
  }
}

.aha-button-grid-view {
  @apply flex flex-none justify-center;
  @apply flex items-center w-52 h-full;

  .close-gridview {
    &:hover {
      .icon-close {
        @apply text-primary-90;
      }
    }
  }
  span {
    @apply hover:text-primary-90 cursor-pointer;
  }
}

.aha-left-column-bottom {
  @apply flex border-t border-base-30 px-2 py-4 relative;
}
.slide-drag {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  top: 0;
}
.slide-rearrange-options {
  @apply opacity-0 absolute w-full h-full left-0 top-0 m-0 cursor-pointer;
}

.reset-results-button {
  @apply mb-1;
}

.aha-slide-grid-action {
  @apply hidden flex-1;
  animation: opengrid 0.3s;

  li {
    transition: all .1s;
    margin-right: 2.25rem;
    @apply inline cursor-pointer;

    &.disabled {
      @apply cursor-not-allowed hover:text-base-90;
      a {
        opacity: 0.6;
        pointer-events: none;
        cursor: not-allowed;
        &:hover {
          color: #4B4B4B !important;
        }
      }
    }

    span {
      transition: all .1s;
    }

    &:not(.disabled):hover {
      @apply text-primary-90 cursor-pointer;

      span {
        @apply text-primary-90 cursor-pointer;
      }
    }

    &.aha-slide-delete-button:hover {
      @apply text-red-50;
      span {
        @apply text-red-50;
      }
    }

    select {
      transition: all .1s;
      @apply text-base-90 cursor-pointer;
    }
  }

  &.not-allow {
    li, span, a {
      cursor: not-allowed;
    }
  }
}

@keyframes showgriditem {
  0% {  @apply w-52; }
  99% {   @apply w-52; }
  100% {  @apply w-full;}
}

@keyframes opengrid {
  0% { opacity: 0; position: absolute;  }
  99% { opacity: 0; position: absolute; }
  100% { opacity: 1; position: unset;}
}

.aha-slide-grid-close {
  @apply hidden justify-center items-center pl-8 cursor-pointer text-base-90 pr-8;
  &:hover {
    @apply text-primary-90;

    svg {
      @apply text-primary-90;
    }
  }
}

.show-grid-slide {
  .aha-slide-grid-action {
    @apply flex my-3 justify-between;
  }
  .left-nav-upper {
    width: 202px;
  }
  .aha-slide-item {
    @apply py-3;
  }
  .aha-slide-grid-close {
    @apply flex;
  }
  &.is-right-nav-active {
    margin-right: 0.5rem;
  }
  .aha-slide-delete-button {
    @apply mr-0;
  }
}

.aha-slide_infoicon {
  @apply rounded-full;
  background-color: #fff;
}

.list-group {
  transition: 0.2s ease;
  &.list-group-grid {
    animation: showgriditem 0.2s ease;
    transition: all 0.2s ease;
    @apply grid justify-center content-center items-center;
    grid-template-columns: repeat(auto-fit, minmax(160px, 224px));
  }
}

.aha-slide-title.aha-slide-title-bg {
  background-color: rgba(0,0,0,.38);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  &.dark {
    background-color: hsla(0,0%,100%,.9);
  }
}

.overlay-disable-grid-action {
  @apply bg-base-0 opacity-50 absolute top-0 left-0 w-full h-full;
  z-index: 9;
}

@media (max-width: 1453px) {
  .aha-slide-grid-action  {
    li {
      @apply mr-2;
    }
  }
}
@media (max-width: $grid-view-label-hidden-breakpoint) {
  .right-nav--opening {
    .grid-view__button-label {
      @apply hidden;
    }
  }
}

// @media (max-width: 765px) {

// }

.context-menu-item.context-menu-duplicate{
  .text-duplicate-slide {
    margin-right: 16px;
  }
  .icon-d-key{
    margin-left: 4px;
  }
}

.btn-cta {
  @apply bg-base-10 rounded;
}
@media (min-width: 1200px) {
  .btn-cta:hover {
    box-shadow: 0 0 0 2px $primary-color;

    svg {
      color: $primary-color;
    }
  }
}
.grid-view__button-wrapper {
  @apply relative flex items-center justify-center w-max;
  @apply border-l border-r border-secondary-20;
  @apply px-6;
  .grid-view__button-label {
    @apply text-base-90 hover:text-primary-90;
  }
}
</style>
